import { addLogSink } from './chunk-GPJ572YS.js';
import { globalSingleton } from './chunk-N7SZ66QO.js';

// src/observability/index.ts
var clients = globalSingleton("observability/clients", () => ({
  rum: null,
  sentry: null
}));
async function initObservability(config) {
  if (config.rum) {
    try {
      const rumSpecifier = "aws-rum-web";
      const mod = await import(
        /* @vite-ignore */
        rumSpecifier
      );
      clients.rum = new mod.AwsRum(
        config.rum.applicationId,
        config.rum.applicationVersion ?? "1.0.0",
        config.rum.region,
        {
          sessionSampleRate: 1,
          identityPoolId: config.rum.identityPoolId,
          endpoint: config.rum.endpoint ?? `https://dataplane.rum.${config.rum.region}.amazonaws.com`,
          telemetries: config.rum.telemetries ?? ["errors", "performance", "http"],
          allowCookies: config.rum.allowCookies ?? true,
          enableXRay: config.rum.enableXRay ?? false
        }
      );
    } catch {
    }
  }
  if (config.sentry) {
    try {
      const sentrySpecifier = "@sentry/browser";
      clients.sentry = await import(
        /* @vite-ignore */
        sentrySpecifier
      );
      clients.sentry.init({
        dsn: config.sentry.dsn,
        environment: config.sentry.environment,
        release: config.sentry.release,
        tracesSampleRate: config.sentry.tracesSampleRate ?? 0.1
      });
    } catch {
    }
  }
  if (config.forwardLogs) wireLogForwarding();
}
function wireLogForwarding() {
  return addLogSink((record) => {
    if (record.level === "error") {
      captureException(new Error(`[${record.namespace}] ${record.message}`), record.context);
    } else if (record.level === "warn") {
      addBreadcrumb(record.namespace, record.message, record.context);
    }
  });
}
function captureException(error, context) {
  clients.rum?.recordError(error);
  clients.sentry?.captureException(error, context ? { extra: context } : void 0);
}
function captureMessage(message, level = "info") {
  clients.sentry?.captureMessage(message, level);
}
function addBreadcrumb(category, message, data) {
  clients.sentry?.addBreadcrumb({ category, message, data, level: "info" });
}
function recordApiResponse(info) {
  clients.rum?.recordEvent("authe_api_request", info);
  if (info.status >= 500) addBreadcrumb("http", `HTTP ${info.status} ${info.url}`, info);
}
function _resetObservability() {
  clients.rum = null;
  clients.sentry = null;
}

export { _resetObservability, addBreadcrumb, captureException, captureMessage, initObservability, recordApiResponse, wireLogForwarding };
//# sourceMappingURL=chunk-MKZZ4UYS.js.map
//# sourceMappingURL=chunk-MKZZ4UYS.js.map